module.exports = __webpack_public_path__ + "img/logo-webtroc.2626d53f.png";